module.exports = __webpack_public_path__ + "img/wechat.fcc01711.png";